import BaseModel from "../base_model.js";

class RawIdentityDocumentModel extends BaseModel {

  i18nScope() {
    return "model.users.identity_document";
  }
}
const IdentityDocumentModel = new RawIdentityDocumentModel();

export { RawIdentityDocumentModel, IdentityDocumentModel }

